import { apiAction } from "./index.js";

export const notificationCheckGet = () => apiAction("/notification/check");
export const notificationFilterGet = (page = 1, limit = 100, filter = "") => apiAction(
  `/notification/filter?&page=${page}&limit=${limit}&filter=${filter}`,
);
